/* DISTRIBUSI HP — PELANGGAN: Data Pelanggan (board 1) and its Filter sheet (1b). Same list call, chips, order
   and CSV as DistCustomers (DLIST, dist-list-logic.js); every old list action is on the card, in the Filter
   sheet, or in ⋯ (which opens the old modals: Kelola Tipe, Impor, Tagih via WA, criteria panel). */

// A customer's Maps link is free text (the API does not check its scheme): only http(s) ever reaches an href.
const dhpSafeUrl = (u) => { const s = String(u || '').trim(); return /^https?:\/\//i.test(s) ? s : ''; };
// A moved pin's Maps link — the same format setCustomerLocation writes on the server.
const dhpPinMapsUrl = (lat, lng) => 'https://www.google.com/maps?q=' + lat + ',' + lng;
const dhpWa = (phone) => { const n = String(phone || '').replace(/[^0-9]/g, '').replace(/^0/, '62'); return n ? 'https://wa.me/' + n : ''; };
const dhpDays = (d) => (Array.isArray(d) && d.length >= 7 ? trDh('dhp.everyDay') : fmtDays(d));
const dhpUrlP = (k, d) => { try { return new URLSearchParams(window.location.search).get(k) || d; } catch (e) { return d; } };
function dhpDownloadCsv(csv, name) {
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name;
  document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

// Filter (1b): changes apply at once (as the old chips do); the CTA closes the sheet and names the count.
function DhpCustFilter({ fleet, fleetScope, distFleet, setDistFleet, show, setShow, typ, setTyp, types, statusFilter, setStatusFilter, canDelete, sort, setSort, sortOpts, gapOk, counts, n, advN, onAdvanced, onReset, onClose }) {
  const chip = (key, on, label, onClick) => <button key={key} type="button" className={'dhp-chip' + (on ? ' on' : '')} aria-pressed={on} onClick={onClick}>{label}</button>;
  const fl = (fleet || []).filter(Boolean);
  const typeOpts = [['reguler', trDh('dist.filterReg')], ['bulk', trDh('dist.filterBulk')], ...(types || []).filter((t) => t.id !== 'reguler' && t.id !== 'bulk').map((t) => [t.id, t.label || t.id])];
  return (
    <div className="dhp-tok">
      <DhpSheet title={trDh('dhp.filter')} onClose={onClose} cta={<>
        <button type="button" className="mlap-btn" onClick={onReset}>{trDh('dhp.reset')}</button>
        <button type="button" className="mlap-btn primary" onClick={onClose}>{trDh('dhp.showN', { n })}</button>
      </>}>
        {!isScoped(fleetScope) && fl.length ? (<>
          <div className="dhp-lbl">{trDh('dhp.fleetLbl')}</div>
          <div className="dhp-wrap">{chip('all', (distFleet || 'all') === 'all', trDh('dist.fleetAll'), () => setDistFleet('all'))}{fl.map((f) => chip(f, distFleet === f, f, () => setDistFleet(f)))}</div>
        </>) : null}
        <div className="dhp-lbl">{trDh('dhp.showLbl')}</div>
        <div className="dhp-wrap">
          {chip('all', show === 'all', trDh('dist.fAll'), () => setShow('all'))}
          {chip('bon', show === 'bon', trDh('dist.filterBon'), () => setShow('bon'))}
          {chip('galon', show === 'galon', trDh('cl.chipGalon'), () => setShow('galon'))}
          {chip('belum', show === 'belum', trDh('dist.filterIncomplete') + (counts.belum ? ' · ' + counts.belum : ''), () => setShow('belum'))}
          {gapOk ? chip('gap7', show === 'gap7', trDh('cl.chipGap7') + ' · ' + counts.gap7, () => setShow('gap7')) : null}
          {gapOk ? chip('gap14', show === 'gap14', trDh('cl.chipGap14') + ' · ' + counts.gap14, () => setShow('gap14')) : null}
        </div>
        <div className="dhp-lbl">{trDh(canDelete ? 'dhp.typeStatus' : 'dhp.typeLbl')}</div>
        <div className="dhp-wrap">
          {chip('t-all', typ === 'all', trDh('dhp.allTypes'), () => setTyp('all'))}
          {typeOpts.map(([k, l]) => chip('t-' + k, typ === k, l, () => setTyp(k)))}
          {canDelete ? <>{chip('st-a', statusFilter !== 'inactive', trDh('dist.stActive'), () => setStatusFilter('active'))}{chip('st-i', statusFilter === 'inactive', trDh('dist.stInactive'), () => setStatusFilter('inactive'))}</> : null}
        </div>
        <div className="mlap-card dhp-card">
          <label className="dhp-fld">
            <span className="dhp-lb">{trDh('cl.sortBy')}</span>
            <select className="dhp-sel" value={sort} onChange={(e) => setSort(e.target.value)}>{sortOpts.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
            <FldSvg n="right" s={16} />
          </label>
          <button type="button" className="dhp-fld" onClick={onAdvanced}>
            <span className="dhp-lb">{trDh('dhp.advanced')}<small>{trDh('dhp.advancedSub')}</small></span>
            {advN ? <span className="dhp-tag p">{advN}</span> : null}
            <FldSvg n="right" s={16} />
          </button>
        </div>
      </DhpSheet>
    </div>
  );
}

// Ubah / Tambah Pelanggan (board 6): an iOS-style form (label left, value right) in grouped white cards. State
// and body come from DLIST (custFormInit / custFormBody), the same as the old modal, so both save alike.
// "-8.6268, 115.1886 · ±8 m" (board 6); without a known accuracy just the coordinates
const dhpPtText = (pt, acc) => { const p = pt.lat.toFixed(4) + ', ' + pt.lng.toFixed(4); return acc != null ? trDh('dhp.ptAcc', { p, m: Math.round(acc) }) : p; };
const dhpWaShow = (p) => String(p || '').replace(/^\+?62/, '').replace(/^0/, '');
function DhpSwitch({ on, onChange, label, sub }) {
  return (
    <label className="dhp-fld">
      <span className="dhp-lb">{label}{sub ? <small>{sub}</small> : null}</span>
      <input type="checkbox" className="dhp-sw" role="switch" checked={!!on} aria-label={label} onChange={(e) => onChange(e.target.checked)} />
    </label>
  );
}
function DhpCustEdit({ cust, types, fleet, canCustomers, canPrice, onSaved, onClose, onPin }) {
  useDhpKbInset();
  const tl = (types && types.length ? types : [{ id: 'reguler', label: 'Reguler' }]);
  const [f, setF] = uSdh(() => DLIST.custFormInit(cust, tl[0].id));
  const [busy, setBusy] = uSdh(false);
  const [err, setErr] = uSdh('');
  const set = (p) => setF((x) => Object.assign({}, x, p));
  // Atur titik from this form gives the customer a new point: the form takes its new Maps link, so Simpan never
  // writes the old one back over it.
  const ptKey = cust ? cust.lat + ',' + cust.lng : '';
  const firstPt = uRdh(ptKey);
  const moved = uRdh(false);
  moved.current = ptKey !== firstPt.current;
  uEdh(() => { if (cust && cust.lat != null && cust.lng != null && moved.current) set({ mapsUrl: dhpPinMapsUrl(cust.lat, cust.lng) }); }, [ptKey]);
  const setR =(p) => setF((x) => Object.assign({}, x, { reminder: Object.assign({}, x.reminder, p) }));
  const toggleDay = (d) => setF((x) => Object.assign({}, x, { deliveryDays: x.deliveryDays.includes(d) ? x.deliveryDays.filter((y) => y !== d) : x.deliveryDays.concat([d]) }));
  const num = (v) => Math.max(0, parseInt(String(v || '').replace(/[^0-9]/g, ''), 10) || 0);
  const fl = (fleet || []).filter(Boolean);
  const armadaOpts = [['', trDh('dist.noArmada')], ...fl.map((a) => [a, a]), ...(f.armada && !fl.includes(f.armada) ? [[f.armada, f.armada + ' ' + trDh('dist.armadaInactive')]] : [])];
  const pt = cust && typeof cust.lat === 'number' && typeof cust.lng === 'number' ? { lat: cust.lat, lng: cust.lng } : null;
  const ptText = pt ? dhpPtText(pt, cust.locationAccuracy) : '';
  const ptBy = pt && cust.locationSetByName ? trDh('dhp.pinBy', { who: cust.locationSetByName, d: cust.locationSetAt ? fmtDateShort(cust.locationSetAt) : '' }) : '';
  const r = f.reminder || {};
  const save = () => {
    if (busy) return;
    const b = DLIST.custFormBody(f);
    if (b.err) { setErr(trDh(b.err)); return; }
    setBusy(true); setErr('');
    const req = cust ? window.API.distribusi.customers.update(cust.id, b.body) : window.API.distribusi.customers.create(b.body);
    req.then((res) => { setBusy(false); onSaved((res && res.data) || null, !cust); })
      .catch((e) => { setBusy(false); setErr(fldErrMsg(e) || trDh('dist.loadErr')); });
  };
  return (
    <div className="dhp-tok dhp-entry dhp-custedit">
      <DhpTop title={trDh(cust ? 'dist.editCust' : 'dist.addCust')} onBack={onClose} backKind="pill" />
      <div className="dhp-entry-body">
        <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.gMain')}</div>
        <div className="mlap-card dhp-card">
          <label className="dhp-fld dhp-frow"><span className="dhp-fk">{trDh('dhp.fName')}</span>
            <input className="dhp-txt dhp-fv" value={f.name} maxLength={120} aria-label={trDh('dist.cfName')} placeholder={trDh('dist.cfNamePh')} onChange={(e) => set({ name: e.target.value })} /></label>
          <label className="dhp-fld dhp-frow"><span className="dhp-fk">{trDh('dhp.fWa')}</span>
            <span className="dhp-wa"><span aria-hidden="true">+62</span><input className="dhp-txt dhp-fv" type="tel" inputMode="tel" value={dhpWaShow(f.phone)} aria-label={trDh('dist.cfPhone')} placeholder="812-3456-7890"
              onChange={(e) => set({ phone: e.target.value })} onBlur={() => set({ phone: normalizePhone(f.phone) })} /></span>
            {f.phone ? <a className="dhp-tag ok dhp-watest" href={'https://wa.me/' + waNumber(f.phone)} target="_blank" rel="noopener noreferrer"><FldSvg n="check" s={12} sw={2.4} />{trDh('dhp.waTest')}</a> : null}</label>
          <label className="dhp-fld dhp-frow"><span className="dhp-fk">{trDh('dhp.typeLbl')}</span>
            <select className="dhp-sel dhp-fv" value={f.type} aria-label={trDh('dist.cfType')} onChange={(e) => set({ type: e.target.value })}>{tl.map((t) => <option key={t.id} value={t.id}>{t.label || t.id}</option>)}</select>
            <FldSvg n="right" s={16} /></label>
        </div>

        <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.gLoc')}</div>
        <div className="mlap-card dhp-card">
          {pt ? <FldMiniMap pt={pt} caption={null} /> : null}
          <div className="dhp-fld">
            <span className="dhp-lb sub2">{pt ? ptText : trDh('dhp.noPin')}<small>{pt ? ptBy : trDh('dhp.noPinSub')}</small></span>
            {onPin ? <button type="button" className="mlap-btn primary dhp-pinbtn" onClick={() => onPin(cust)}>{trDh('dhp.setPin')}</button> : null}
          </div>
          {dhpSafeUrl(f.mapsUrl) ? <a className="dhp-fld dhp-link" href={dhpSafeUrl(f.mapsUrl)} target="_blank" rel="noopener noreferrer"><FldSvg n="pin" s={16} />{trDh('dist.openMaps')}</a> : null}
          <label className="dhp-fld dhp-frow"><span className="dhp-fk">{trDh('dhp.fAddr')}</span>
            <input className="dhp-txt dhp-fv" value={f.address} maxLength={300} aria-label={trDh('dist.cfAddress')} placeholder={trDh('dist.cfAddressPh')} onChange={(e) => set({ address: e.target.value })} /></label>
          <label className="dhp-fld dhp-frow"><span className="dhp-fk">{trDh('dhp.fMaps')}</span>
            <input className="dhp-txt dhp-fv" type="url" value={f.mapsUrl} maxLength={500} aria-label={trDh('dist.cfMapsUrl')} placeholder={trDh('dhp.optional')}
              onChange={(e) => set({ mapsUrl: e.target.value, _lat: undefined, _lng: undefined, _accuracy: undefined })} /></label>
        </div>

        <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.gDeliv')}</div>
        <div className="mlap-card dhp-card">
          <label className="dhp-fld"><span className="dhp-lb">{trDh('dhp.fleetLbl')}</span>
            <select className="dhp-sel" value={f.armada} aria-label={trDh('dist.cfArmada')} onChange={(e) => set({ armada: e.target.value })}>{armadaOpts.map(([v, l]) => <option key={v || '-'} value={v}>{l}</option>)}</select>
            <FldSvg n="right" s={16} /></label>
          <div className="dhp-days" role="group" aria-label={trDh('dist.cfDays')}>
            {DAY_CODES.map((d) => <button key={d} type="button" aria-pressed={f.deliveryDays.includes(d)} className={f.deliveryDays.includes(d) ? 'on' : ''} onClick={() => toggleDay(d)}>{d}</button>)}
          </div>
          <DhpSwitch on={f.fixedDays} onChange={(v) => set({ fixedDays: v })} label={trDh('cust.fixedDays')} sub={f.fixedDays ? trDh('cust.fixedHint') : ''} />
        </div>

        <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.gOther')}</div>
        <div className="mlap-card dhp-card">
          <DhpSwitch on={r.enabled} onChange={(v) => setR({ enabled: v })} label={trDh('dist.remTitle')} sub={trDh('dist.remSub')} />
          {r.enabled ? (<>
            <DhpMoneyRow label={trDh('dist.remBon')} value={r.bonThreshold || 0} onChange={(v) => setR({ bonThreshold: v })} />
            {[['gallonThreshold', 'dist.remGallon', 0], ['overdueDays', 'dist.remOverdue', 0], ['dueDay', 'dist.remDueDay', 31]].map(([k, lk, max]) => (
              <label key={k} className="dhp-fld"><span className="dhp-lb">{trDh(lk)}</span>
                <input className="dhp-num" inputMode="numeric" value={r[k] || ''} placeholder="0" aria-label={trDh(lk)} onChange={(e) => setR({ [k]: max ? Math.min(max, num(e.target.value)) : num(e.target.value) })} /></label>
            ))}
            <div className="dhp-fld dhp-fcol"><span className="dhp-lb">{trDh('dist.remWeekly')}</span>
              <div className="dhp-wrap0">
                <button type="button" className={'dhp-chip' + (!r.weekday ? ' on' : '')} onClick={() => setR({ weekday: '' })}>{trDh('dist.remOff')}</button>
                {DAY_CODES.map((d) => <button key={d} type="button" className={'dhp-chip' + (r.weekday === d ? ' on' : '')} onClick={() => setR({ weekday: d })}>{d}</button>)}
              </div>
              <small className="dhp-hint">{trDh('dist.remHint')}</small>
            </div>
          </>) : null}
          {!cust ? (
            <>
              <DhpMoneyRow label={trDh('dist.cfPrice')} value={num(f.price)} onChange={(v) => set({ price: v ? String(v) : '' })} />
              <div className="dhp-fld"><span className="dhp-lb sub"><FldSvg n="lock" s={14} />{trDh('dist.cfPriceNote')}</span></div>
            </>
          ) : <div className="dhp-fld"><span className="dhp-lb sub"><FldSvg n="lock" s={14} />{trDh('dist.cfPriceEditNote')}</span></div>}
        </div>
        {err ? <div className="mlap-err dhp-err" role="alert">{err}</div> : null}
        <div className="mlap-ctaspace dhp-ctaspace" />
      </div>
      <FldCtaBar>
        <button type="button" className="mlap-btn primary" disabled={busy || !String(f.name || '').trim()} onClick={save}>{busy ? trDh('dhp.saving') : trDh('dist.cfSave')}</button>
      </FldCtaBar>
    </div>
  );
}

// Where a moved point is saved: the location endpoint for a holder of distribusiLokasiSimpan (method geser, the
// reason as its note), else the customer PATCH (customers cap) with the same method + note, so both leave a
// history row that says who moved it, when, and why.
function dhpLocApi(perms) {
  return {
    setLocation: (id, body) => (perms && perms.distribusiLokasiSimpan
      ? window.API.distribusi.customers.setLocation(id, body)
      : window.API.distribusi.customers.update(id, { lat: body.lat, lng: body.lng, mapsUrl: dhpPinMapsUrl(body.lat, body.lng), locationMethod: 'geser', locationNote: body.note || '' })),
  };
}
const dhpHistWhen = (ms) => { try { return dhpDateFmt(new Date(ms), { day: 'numeric', month: 'short' }); } catch (e) { return ''; } };

// Atur titik (board 6b): Mode Lapangan's pan-the-map pin screen (FldPinMap with `office`). Past 150 m from the
// old point — or far from the phone — the guard sheet (6c) asks before saving; past 150 m a reason is required.
function DhpAturTitik({ cust, perms, rules, onDone, onClose }) {
  const old = typeof cust.lat === 'number' && typeof cust.lng === 'number' ? { lat: cust.lat, lng: cust.lng } : null;
  // no old point: FldPinMap starts from the phone's GPS, else from the warehouse (Peta Zona) when the user may read it
  const [depot, setDepot] = uSdh(() => (old || !(perms && perms.distribusiZona) ? null : undefined));
  const [ask, setAsk] = uSdh(null);        // { g, resolve } while the guard sheet is open
  const [reason, setReason] = uSdh('');
  const [text, setText] = uSdh('');
  const [hist, setHist] = uSdh(null);
  const [histOpen, setHistOpen] = uSdh(false);
  const [paste, setPaste] = uSdh(null);    // { v, msg } while the paste sheet is open
  const api = uMdh(() => dhpLocApi(perms), [perms]);
  uEdh(() => {
    if (depot !== undefined) return undefined;
    let live = true;
    window.API.distribusi.zones.list().then((r) => { if (live) setDepot((r && r.data && r.data.depot) || null); }).catch(() => { if (live) setDepot(null); });
    return () => { live = false; };
  }, []);
  uEdh(() => {
    let live = true;
    window.API.distribusi.customers.locationHistory(cust.id).then((r) => { if (live) setHist((r && r.data) || []); }).catch(() => { if (live) setHist([]); });
    return () => { live = false; };
  }, [cust.id]);
  const office = uMdh(() => ({
    beforeSave: ({ pin, dev }) => {
      const g = HPLOGIC.pinGuard({ old, pin, device: dev });
      if (!g.needReason && !g.devWarn) return {};
      return new Promise((resolve) => { setReason(''); setText(''); setAsk({ g, resolve }); });
    },
    onPaste: () => setPaste({ v: '', msg: '' }),
  }), []);
  const closeAsk = (x) => { if (ask) ask.resolve(x); setAsk(null); };
  const g = ask ? ask.g : null;
  const problem = !!g && ((g.needReason && !reason) || (reason === 'other' && !text.trim()));
  const warn = !g ? '' : g.needReason && g.devWarn ? trDh('dhp.pinWarnBoth', { a: numX(g.fromOldM), b: numX(g.devM) })
    : g.needReason ? trDh('dhp.pinWarnOld', { a: numX(g.fromOldM) }) : trDh('dhp.pinWarnDev', { b: numX(g.devM) });
  const goPaste = () => {
    const p = HPLOGIC.parseMapsLink(paste.v);
    if (!p) { setPaste(Object.assign({}, paste, { msg: 'dhp.pinBad' })); return; }
    if (p.short) { setPaste(Object.assign({}, paste, { msg: 'dhp.pinShort' })); return; }
    if (office.setView) office.setView([p.lat, p.lng], 18);
    setPaste(null);
  };
  const histRows = (hist || []).slice(0, 5);
  const histCard = (
    <div className="mlap-card dhp-card dhp-hist">
      {hist === null ? <div className="dhp-fld"><span className="dhp-lb sub">{trDh('dhp.loading')}</span></div> : null}
      {hist && !histRows.length ? <div className="dhp-fld"><span className="dhp-lb sub">{trDh('dhp.pinHistNone')}</span></div> : null}
      {histRows.map((h, i) => (
        <div key={h.id} className="mlap-kv">
          <span>{[dhpHistWhen(h.at), h.actorName, trDh('dhp.pinM_' + (h.action === 'clear' ? 'clear' : h.method === 'geser' || h.method === 'form' ? h.method : 'gps'))].filter(Boolean).join(' · ')}{h.note ? <small className="dhp-hint"> — {h.note}</small> : null}</span>
          <b className={i ? 'dhp-sbt' : ''}>{i === 0 ? trDh('dhp.pinNow') : h.movedM != null ? numX(h.movedM) + ' m' : '—'}</b>
        </div>
      ))}
    </div>
  );
  // "Riwayat titik" — a row in the sheet under the map, just above Save
  office.extra = (
    <button type="button" className="dhp-histrow" onClick={() => setHistOpen(true)}>
      <FldSvg n="clock" s={15} /><span>{trDh('dhp.pinHist')}{hist && hist.length ? ' · ' + hist.length : ''}</span><FldSvg n="right" s={15} />
    </button>
  );
  return (
    <div className="dhp-tok dhp-entry dhp-pin">
      {depot === undefined ? <div className="mlap-empty">{trDh('dhp.loading')}</div>
        : <FldPinMap api={api} cust={cust} depot={depot} rules={rules || {}} office={office} onBack={onClose} onDone={(msg, pt) => onDone(pt, msg)} />}
      {histOpen ? <DhpSheet title={trDh('dhp.pinHist')} onClose={() => setHistOpen(false)}>{histCard}</DhpSheet> : null}
      {paste ? (
        <DhpSheet title={trDh('dhp.pinPaste')} onClose={() => setPaste(null)} cta={<button type="button" className="mlap-btn primary" disabled={!paste.v.trim()} onClick={goPaste}>{trDh('dhp.pinGo')}</button>}>
          <div className="mlap-card dhp-card"><label className="dhp-fld">
            <input className="dhp-txt dhp-fv" type="url" autoFocus value={paste.v} placeholder="https://maps.google.com/…" aria-label={trDh('dhp.pinPaste')} onChange={(e) => setPaste({ v: e.target.value, msg: '' })} />
          </label></div>
          {paste.msg ? <div className="mlap-err" role="alert">{trDh(paste.msg)}</div> : null}
        </DhpSheet>
      ) : null}
      {ask ? (
        <DhpSheet title={trDh('dhp.pinAskT')} onClose={() => closeAsk(null)} cta={<>
          <button type="button" className="mlap-btn" onClick={() => closeAsk(null)}>{trDh('dhp.back')}</button>
          <button type="button" className="mlap-btn primary" disabled={problem} onClick={() => closeAsk({ note: HPLOGIC.pinNote(reason, text, trDh) })}>{trDh('dhp.pinYes')}</button>
        </>}>
          <div className="mlap-note dhp-pinwarn"><FldSvg n="warn" s={16} /><span>{warn}</span></div>
          <div className="dhp-lbl">{trDh(g.needReason ? 'dhp.pinReason' : 'dhp.pinReasonOpt')}</div>
          <div className="dhp-wrap">
            {HPLOGIC.PIN_REASONS.map((k) => <button key={k} type="button" className={'dhp-chip' + (reason === k ? ' on' : '')} aria-pressed={reason === k} onClick={() => setReason(reason === k ? '' : k)}>{trDh('dhp.pinR_' + k)}</button>)}
          </div>
          {reason === 'other' ? <div className="mlap-card dhp-card"><label className="dhp-fld"><input className="dhp-txt dhp-fv" value={text} maxLength={200} autoFocus placeholder={trDh('dhp.pinOtherPh')} aria-label={trDh('dhp.pinOtherPh')} onChange={(e) => setText(e.target.value)} /></label></div> : null}
          <div className="dhp-lbl">{trDh('dhp.pinHist')}</div>
          {histCard}
        </DhpSheet>
      ) : null}
    </div>
  );
}

function DhpCustomers(props) {
  const { hp, canCustomers, canCustImport, canInput, canDelete, refreshKey, fleet, fleetScope, distFleet, setDistFleet, onChanged, nav, histTick } = props;
  const scrollRef = uRdh(null);
  const scrolled = useDhpScrolled(scrollRef);
  const [detailId, setDetailId] = uSdh(() => dhpUrlP('c', ''));
  const [custs, setCusts] = uSdh(null);
  const [gapOk, setGapOk] = uSdh(false);
  const [loadErr, setLoadErr] = uSdh('');
  const [types, setTypes] = uSdh([]);
  const [q, setQ] = uSdh(() => dhpUrlP('q', ''));
  const [show, setShow] = uSdh(() => { const c = dhpUrlP('chip', 'all'); return c === 'reguler' || c === 'bulk' ? 'all' : c; });
  const [typ, setTyp] = uSdh(() => { const c = dhpUrlP('chip', 'all'); return c === 'reguler' || c === 'bulk' ? c : dhpUrlP('ty', 'all'); });
  const [sort, setSort] = uSdh(() => dhpUrlP('sort', 'nama'));
  const [statusFilter, setStatusFilter] = uSdh(() => dhpUrlP('st', 'active'));
  const [flt, setFlt] = uSdh(EMPTY_FILTER);
  const [vis, setVis] = uSdh(30);
  const [sheet, setSheet] = uSdh('');      // '' | 'filter' | 'more'
  const [adv, setAdv] = uSdh(false);       // the old criteria panel (CustomerFilterPanel)
  const [modal, setModal] = uSdh('');      // '' | 'types' | 'import'
  const [bulkWa, setBulkWa] = uSdh(null);
  const [edit, setEdit] = uSdh(null);      // {} → Tambah Pelanggan (board 6); a customer → Ubah
  const [pinFor, setPinFor] = uSdh(null);  // a customer → Atur titik (board 6b)
  const [toast, setToast] = uSdh('');
  const sentinel = uRdh(null);
  const latest = uRdh(0);
  const qMounted = uRdh(false);

  const ef = effFleet(fleetScope, distFleet);
  const canPin = !!(hp.perms && (hp.perms.distribusiLokasiSimpan || hp.perms.distribusiCustomers));
  const flash = (m) => { setToast(m); setTimeout(() => setToast(''), 2600); };
  // Same request as the old list (fleet, status, server criteria + search); a stalled request ends in an error +
  // retry after 20 s, and a slower earlier answer never overwrites a newer one.
  const reload = () => {
    if (!(window.API && window.API.distribusi)) return Promise.resolve();
    const my = ++latest.current;
    setLoadErr('');
    const timeout = new Promise((_, rej) => setTimeout(() => rej(new Error('timeout')), 20000));
    const st = (canDelete && statusFilter === 'inactive') ? 'inactive' : 'active';
    return Promise.race([window.API.distribusi.customers.list(ef, st, { ...flt, q }), timeout])
      .then((r) => { if (my !== latest.current) return; setCusts(r.data || []); setGapOk(!!r.deliveryGap); })
      .catch((e) => { if (my !== latest.current) return; setLoadErr((e && e.body && e.body.error && e.body.error.message) || trDh('common.loadFail')); });
  };
  const retry = () => { setCusts(null); reload(); };
  const reloadTypes = () => window.API.distribusi.types.list().then((r) => setTypes(r.data || [])).catch(() => {});
  uEdh(() => { reload(); }, [ef, statusFilter, flt, refreshKey]);
  uEdh(() => {
    if (!qMounted.current) { qMounted.current = true; return undefined; }
    const t = setTimeout(() => reload(), 300);
    return () => clearTimeout(t);
  }, [q]);
  uEdh(() => { reloadTypes(); }, []);
  uEdh(() => { setVis(30); }, [q, show, typ, sort, statusFilter, flt, ef]);
  // the list controls live in the URL, as the old list's do, so a detail round-trip restores them
  uEdh(() => {
    try {
      const u = new URL(window.location.href);
      const setp = (k, v, dflt) => { if (v && v !== dflt) u.searchParams.set(k, v); else u.searchParams.delete(k); };
      setp('q', q, ''); setp('chip', show, 'all'); setp('ty', typ, 'all'); setp('sort', sort, 'nama'); setp('st', statusFilter, 'active');
      window.history.replaceState(window.history.state, '', u);
    } catch (e) { /* no URL API */ }
  }, [q, show, typ, sort, statusFilter]);
  // Back / forward (the shell's single popstate) re-reads the open customer and its tab from the URL
  const [dTab, setDTab] = uSdh(() => dhpUrlP('tab', 'ringkasan'));
  uEdh(() => { setDetailId(dhpUrlP('c', '')); setDTab(dhpUrlP('tab', 'ringkasan')); }, [histTick]);
  uEdh(() => {
    const el = sentinel.current; if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    const io = new IntersectionObserver((ents) => { if (ents.some((x) => x.isIntersecting)) setVis((n) => n + 40); }, { root: scrollRef.current, rootMargin: '800px' });
    io.observe(el); return () => io.disconnect();
  }, [custs, detailId]);

  const pushSub = (mut) => { let sp; try { sp = new URLSearchParams(window.location.search); } catch (e) { sp = new URLSearchParams(); } mut(sp); if (nav && nav.pushSub) nav.pushSub(sp.toString()); };
  const openDetail = (id) => { pushSub((sp) => { sp.set('c', id); sp.set('tab', 'ringkasan'); }); setDTab('ringkasan'); setDetailId(id); };
  // the detail's segments push real history entries too, so Back walks tabs → detail → list (as the old screen)
  const detailTab = (t) => { if (t === dhpTabOf(dTab)) return; pushSub((sp) => sp.set('tab', t)); setDTab(t); };
  const closeDetail = (msg) => { pushSub((sp) => { sp.delete('c'); sp.delete('tab'); }); setDetailId(''); if (msg) { flash(msg); reload(); } };
  const doReactivate = (c) => {
    window.API.distribusi.customers.reactivate(c.id)
      .then(() => { flash(trDh('dist.delReactivated', { name: c.name })); reload(); if (onChanged) onChanged(); })
      .catch((e) => flash(fldErrMsg(e) || trDh('common.loadFail')));
  };


  const typeMap = {}; types.forEach((t) => { typeMap[t.id] = t; });
  const typeLabelOf = (id) => (typeMap[id] && typeMap[id].label) || typeLabel(id);
  const list = custs || [];
  // memoised: a sheet, the title bar or a keystroke in the search box must not re-filter / re-sort 650 customers
  const shown = uMdh(() => DLIST.custSort(list.filter((c) => DLIST.custChipPass(c, show, { gapOk }) && (typ === 'all' || c.type === typ)), sort), [custs, show, typ, sort, gapOk]);
  const rows = uMdh(() => shown.slice(0, vis), [shown, vis]);
  const sumBon = shown.reduce((s, c) => s + (c.sisaBon || 0), 0);
  const sumGalon = shown.reduce((s, c) => s + (c.gallonsHeld || 0), 0);
  const counts = uMdh(() => ({
    belum: list.filter((c) => c.complete === false).length,
    gap7: list.filter((c) => DLIST.custChipPass(c, 'gap7', { gapOk })).length,
    gap14: list.filter((c) => DLIST.custChipPass(c, 'gap14', { gapOk })).length,
  }), [custs, gapOk]);
  const sortOpts = [['nama', trDh('cl.sortName')], ['bon', trDh('cl.sortBon')], ['bonAsc', trDh('cl.sortBonAsc')], ['last', trDh('cl.sortLast')], ['lastAsc', trDh('cl.sortLastAsc')], ['spend', trDh('cl.sortSpend')], ...(gapOk ? [['gap', trDh('cl.sortGap')]] : [])];
  // Picking a gap chip also sorts longest-gap first (the order the delivery team works in), as the old list.
  const pickShow = (k) => { setShow(k); if ((k === 'gap7' || k === 'gap14') && show !== 'gap7' && show !== 'gap14') setSort('gap'); };
  const gapMode = gapOk && (show === 'gap7' || show === 'gap14');
  const gapText = () => deliveryGapMessage(shown, show === 'gap14' ? 14 : 7, printToday());
  const showLabel = { bon: trDh('dist.filterBon'), galon: trDh('cl.chipGalon'), belum: trDh('dist.filterIncomplete'), gap7: trDh('cl.chipGap7'), gap14: trDh('cl.chipGap14') };
  const typName = (k) => (k === 'reguler' ? trDh('dist.filterReg') : k === 'bulk' ? trDh('dist.filterBulk') : typeLabelOf(k));
  const crit = activeFilterChips(flt, setFlt, typeMap);
  const chipsOn = [
    ...(!isScoped(fleetScope) && distFleet && distFleet !== 'all' ? [{ key: 'fleet', label: distFleet, icon: 'truck', clear: () => setDistFleet('all') }] : []),
    ...(show !== 'all' && showLabel[show] ? [{ key: 'show', label: showLabel[show], clear: () => setShow('all') }] : []),
    ...(typ !== 'all' ? [{ key: 'typ', label: typName(typ), clear: () => setTyp('all') }] : []),
    ...(canDelete && statusFilter === 'inactive' ? [{ key: 'st', label: trDh('dist.stInactive'), clear: () => setStatusFilter('active') }] : []),
    ...crit.map((ch) => ({ key: 'f-' + ch.key, label: ch.label, clear: ch.clear })),
  ];
  const resetAll = () => { setShow('all'); setTyp('all'); setFlt(EMPTY_FILTER); if (!isScoped(fleetScope)) setDistFleet('all'); if (canDelete) setStatusFilter('active'); };
  const listState = custs === null ? (loadErr ? 'error' : 'loading') : (shown.length === 0 ? (filterIsEmpty(flt) && show === 'all' && typ === 'all' && !q ? 'empty' : 'nofilter') : 'ready');
  const sub = [trDh('dhp.custSub', { n: numX(shown.length), rp: dhpRp(sumBon), g: numX(sumGalon) }), isScoped(fleetScope) && fleetScope.length ? fleetScope.join(', ') : ''].filter(Boolean).join(' · ');
  const owing = shown.filter((c) => (c.sisaBon || 0) > 0);
  const menu = [
    { labelKey: 'dhp.grpList', items: [
      shown.length ? { key: 'csv', label: trDh('cl.csv'), icon: 'doc', onClick: () => dhpDownloadCsv(DLIST.custCsv(shown, { tr: trDh, typeLabelOf, fmtDays }), 'pelanggan.csv') } : null,
      owing.length ? { key: 'wa', label: trDh('wa.bulkBtn'), icon: 'chat', onClick: () => setBulkWa(owing) } : null,
    ] },
    { labelKey: 'dhp.grpData', items: [
      canCustomers && { key: 'add', label: trDh('dist.addCust'), icon: 'plus', onClick: () => setEdit({}) },
      canCustImport && { key: 'import', label: trDh('dist.import'), icon: 'upload', onClick: () => setModal('import') },
      canCustomers && { key: 'types', label: trDh('dist.kelolaTipe'), icon: 'edit', onClick: () => setModal('types') },
    ] },
    { items: [{ key: 'old', label: trDh('dhp.useOld'), icon: 'swap', onClick: hp.onOld }] },
  ];
  const meta = (c) => [
    dhpDays(c.deliveryDays),
    (c.gallonsHeld || 0) > 0 ? trDh('dhp.galonAt', { n: numX(c.gallonsHeld) }) : '',
    gapMode ? (c.deliveryNever ? trDh('cl.gapNever') : trDh('cl.gapDays', { n: c.deliveryGapDays })) : '',
  ].filter(Boolean).join(' · ');

  // the cards keep their render while a sheet, the title bar or the search box changes around them
  const h = useDhpLatest({ openDetail, doReactivate, hp });
  const langKey = trDh('dhp.lunas');
  const rowEls = uMdh(() => rows.map((c) => {
    const wa = dhpWa(c.phone);
    return (
      <div key={c.id} className={'mlap-card dhp-card dhp-ccard' + (c.active === false ? ' off' : '')}>
        <button type="button" className="dhp-ct" onClick={() => h.current.openDetail(c.id)}>
          <span className="dhp-ini">{dhpIni(c.name)}</span>
          <span className="dhp-grow">
            {c.code ? <span className="dhp-code">{c.code}</span> : null}
            <span className="dhp-nm">{c.name}</span>
            {meta(c) ? <span className="dhp-sbt">{meta(c)}</span> : null}
            {c.complete === false || c.active === false ? (
              <span className="dhp-ctags">
                {c.active === false ? <span className="dhp-tag">{trDh('dist.inactive')}</span> : null}
                {c.complete === false ? <span className="dhp-tag w">{trDh('dist.filterIncomplete')}</span> : null}
              </span>
            ) : null}
          </span>
          <span className="dhp-amt">
            {(c.sisaBon || 0) > 0 ? <><span className="dhp-tag bon">{dhpRp(c.sisaBon)}</span><small>{trDh('dhp.sisaBonSm')}</small></> : <span className="dhp-tag l">{trDh('dhp.lunas')}</span>}
          </span>
        </button>
        <div className="dhp-acts">
          {wa ? <a className="dhp-act" href={wa} target="_blank" rel="noopener noreferrer"><FldSvg n="chat" s={16} />WA</a> : <span className="dhp-act off" aria-disabled="true"><FldSvg n="chat" s={16} />WA</span>}
          {dhpSafeUrl(c.mapsUrl) ? <a className="dhp-act" href={dhpSafeUrl(c.mapsUrl)} target="_blank" rel="noopener noreferrer"><FldSvg n="pin" s={16} />Maps</a> : <span className="dhp-act off" aria-disabled="true"><FldSvg n="pin" s={16} />Maps</span>}
          {canInput && c.active !== false ? <button type="button" onClick={() => h.current.hp.onEntry('sale', { cust: c })} className="dhp-act pri"><FldSvg n="plus" s={16} />{trDh('dhp.addTxn')}</button> : null}
          {canDelete && c.active === false ? <button type="button" className="dhp-act" onClick={() => h.current.doReactivate(c)}><FldSvg n="power" s={16} />{trDh('dist.reactivate')}</button> : null}
        </div>
      </div>
    );
  }), [rows, gapMode, canInput, canDelete, langKey]);

  return (
    <>
      <DhpRoot className="dhp-cust" scrollRef={scrollRef}>
        <div className={'dhp-float' + (scrolled ? ' on' : '')}><DhpTop title={trDh('dhp.tab.dist-customers')} show={scrolled} /></div>
        <DhpHead title={trDh('dhp.tab.dist-customers')} onMenu={hp.onMenu}
          right={<><DhpRound icon="more" label={trDh('dhp.more')} onClick={() => setSheet('more')} />{hp.chrome && hp.chrome.bell}</>} />
        {custs !== null ? <div className="dhp-eyebrow">{sub}</div> : null}
        <DhpChips chips={chipsOn} onRemove={(k) => { const ch = chipsOn.find((x) => x.key === k); if (ch) ch.clear(); }} />
        {gapMode && shown.length ? (
          <div className="dhp-gapacts">
            <button type="button" className="mlap-btn primary" onClick={() => window.open('https://wa.me/?text=' + encodeURIComponent(gapText()), '_blank', 'noopener')}><FldSvg n="chat" s={16} />{trDh('cl.gapSend')}</button>
            <button type="button" className="mlap-btn" onClick={() => copyText(gapText(), () => flash(trDh('cl.gapCopied')))}><FldSvg n="doc" s={16} />{trDh('cl.gapCopy')}</button>
          </div>
        ) : null}
        {loadErr && custs !== null ? <div className="mlap-err dhp-err" role="alert">{loadErr}<button type="button" className="mlap-btn" onClick={retry}>{trDh('common.retry')}</button></div> : null}

        {listState === 'loading' ? <div aria-busy="true">{[0, 1, 2, 3, 4].map((i) => <div key={i} className="dhp-skel" />)}</div> : null}
        {listState === 'error' ? (
          <div className="mlap-card dhp-card mlap-empty" role="alert">{loadErr}<div><button type="button" className="mlap-btn" onClick={retry}>{trDh('common.retry')}</button></div></div>
        ) : null}
        {listState === 'nofilter' ? (
          <div className="mlap-card dhp-card mlap-empty">{trDh('dist.noResultFilter')}<div><button type="button" className="mlap-btn" onClick={() => { resetAll(); setQ(''); }}>{trDh('dist.fReset')}</button></div></div>
        ) : null}
        {listState === 'empty' ? (
          <div className="mlap-card dhp-card mlap-empty">{trDh('cl.emptyTitle')}
            {canCustomers ? <div><button type="button" className="mlap-btn primary" onClick={() => setEdit({})}>{trDh('dist.addCust')}</button></div> : null}
            {canCustImport ? <div><button type="button" className="mlap-btn" onClick={() => setModal('import')}>{trDh('dist.import')}</button></div> : null}
          </div>
        ) : null}

        {listState === 'ready' ? rowEls : null}
        {listState === 'ready' ? <div ref={sentinel} className="dhp-sentinel" /> : null}
        {listState === 'ready' && vis < shown.length ? <div className="dhp-more">{trDh('cl.showingWindow', { n: rows.length, total: shown.length })}</div> : null}

        <DhpSearchPill value={q} onChange={setQ} placeholder={trDh('dhp.searchCust')} onFilter={() => setSheet('filter')} filterCount={chipsOn.length} />
        {toast ? <div className="mlap-toast" role="status">{toast}</div> : null}
      </DhpRoot>

      {sheet === 'filter' ? (
        <DhpCustFilter fleet={fleet} fleetScope={fleetScope} distFleet={distFleet} setDistFleet={setDistFleet} show={show} setShow={pickShow} typ={typ} setTyp={setTyp}
          types={types} statusFilter={statusFilter} setStatusFilter={setStatusFilter} canDelete={canDelete} sort={sort} setSort={setSort} sortOpts={sortOpts}
          gapOk={gapOk} counts={counts} n={numX(shown.length)} advN={crit.length} onAdvanced={() => { setSheet(''); setAdv(true); }} onReset={resetAll} onClose={() => setSheet('')} />
      ) : null}
      {sheet === 'more' ? <div className="dhp-tok"><DhpMenuSheet title={trDh('dhp.tab.dist-customers')} groups={menu} onClose={() => setSheet('')} /></div> : null}
      {adv ? <CustomerFilterPanel value={flt} types={types} onApply={(v) => { setFlt(v); setAdv(false); }} onClose={() => setAdv(false)} /> : null}
      {modal === 'types' ? <CustomerTypesModal types={types} custs={custs} onReload={() => { reloadTypes(); reload(); }} onClose={() => setModal('')} /> : null}
      {modal === 'import' ? <CustomerImportModal types={types} custs={custs} fleet={fleet} onClose={() => setModal('')} onDone={(msg) => { setModal(''); flash(msg); reload(); if (onChanged) onChanged(); }} /> : null}
      {bulkWa ? <BulkWaQueue customers={bulkWa} onClose={() => setBulkWa(null)} /> : null}
      {edit ? <DhpCustEdit cust={edit.id ? edit : null} types={types} fleet={fleet} canCustomers={canCustomers} canPrice={props.canPrice}
        onPin={canPin && edit.id ? (c) => setPinFor(c) : undefined}
        onSaved={(c, added) => { setEdit(null); flash(trDh(added ? 'dist.custAdded' : 'dist.custSaved')); reload(); if (onChanged) onChanged(); }} onClose={() => setEdit(null)} /> : null}
      {pinFor ? <DhpAturTitik cust={pinFor} perms={hp.perms} rules={hp.rules} onClose={() => setPinFor(null)}
        onDone={(pt, msg) => { setPinFor(null); if (edit && edit.id === pinFor.id) setEdit(Object.assign({}, edit, pt)); flash(msg); reload(); if (onChanged) onChanged(); }} /> : null}
      {detailId ? <DhpCustDetail {...props} id={detailId} tab={dTab} onTab={detailTab} onBack={closeDetail}
        onChanged={() => { reload(); if (onChanged) onChanged(); }} /> : null}
    </>
  );
}
